<template>
  <profile-customer-review
    title="Review and confirm customer creation"
    confirm-button-text="create customer"
    :profile="profile"
    :data="customerData"
    :confirm-button-props="{ disabled: createCustomerApiRequest.loading }"
    :cancel-button-props="{ disabled: createCustomerApiRequest.loading }"
    @confirm="onConfirmButtonClick"
    @cancel="closeModal"
  />
</template>

<script>
  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ProfileApi from '@/services/Api/ProfileApi'

  // Events
  import { EVENT_PROFILE_CUSTOMER_CREATE } from '@/events/profileCustomers'

  // Mixins
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Components
  import ProfileCustomerReview from '@/components/profile-customers/ProfileCustomerReview'

  export default {
    name: 'ProfileCustomerCreateModal',
    components: {
      ProfileCustomerReview
    },
    mixins: [modal, flashMessages],
    data () {
      return {
        createCustomerApiRequest: new ApiRequest(
          ProfileApi.createCustomer
        )
      }
    },
    computed: {
      profile () {
        return this.modalData.profile
      },
      customerData () {
        return this.modalData.customer
      },
      postData () {
        const { channel, accountId, ...profileCustomerRequest } = this.customerData

        return {
          channel,
          walletId: accountId,
          profileCustomerRequest: profileCustomerRequest
        }
      }
    },
    methods: {
      onConfirmButtonClick () {
        this.createCustomerApiRequest.execute(this.profile.id, this.postData)
          .then(customerData => {
            this.$eventHub.$emit(EVENT_PROFILE_CUSTOMER_CREATE, customerData)
            this.showSuccessFlashMessage('Customer has been successfully created.')
          })
          .catch(error => {
            this.$eventHub.$emit(EVENT_PROFILE_CUSTOMER_CREATE, error)
            this.showErrorFlashMessage('Customer has not been created.')
          })
      }
    }
  }
</script>
